import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import FormContext from "../context/FormContext";
import Logo from "../assests/logo.jpeg";

const Auth = () => {
  const [User, setUser] = useState({
    dbname: "erp_eshiksa",
    tag: "auth_login",
  });
  const navigate = useNavigate();
  const context = useContext(FormContext);
  const [error, setError] = useState("");
  const { setLoading } = context;

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    await axios
      .post("https://erpapi.eshiksa.net/formLogin.php", {
        ...User,
      })
      .then((res) => {
        setLoading(false);

        if (res.data.success !== 1) {
          setError(res.data.msg);
        } else {
          // setFormList(res.data.formField);
          localStorage.setItem("Branch_id", res.data.Branch_id);
          navigate("/Home");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <div className="container">
        <form
          style={{
            width: 300,
            // border: "1px solid black",
            height: 400,
            padding: 15,
            boxShadow: "1px 4px 10px 3px #9E9E9E",
            borderRadius: 10,
          }}
          className="m-auto "
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          <img style={{ width: "50px" }} alt="eshiksa" src={Logo} />

          <hr className="m-0"></hr>
          <div className="my-4">
            <p className="text-danger">{error}</p>
            <div style={{ textAlign: "start" }} className="mt-3 form-group">
              <label
                style={{
                  fontSize: 15,
                  fontWeight: 300,
                  textTransform: "uppercase ",
                }}
                htmlFor="login_email"
                className="my-2"
              >
                Email
              </label>
              <input
                type="email"
                onChange={(e) =>
                  setUser({ ...User, [e.target.name]: e.target.value })
                }
                className="form-control"
                name="login_email"
                id="login_email"
                placeholder="Email"
                required
                style={{
                  outlineColor: "red",
                }}
              />
            </div>
            <div style={{ textAlign: "start" }} className="mb-3 form-group">
              <label
                style={{
                  fontSize: 15,
                  fontWeight: 300,
                  textTransform: "uppercase",
                }}
                htmlFor="password"
                className="my-2"
              >
                password
              </label>
              <input
                type="password"
                onChange={(e) =>
                  setUser({ ...User, [e.target.name]: e.target.value })
                }
                className="form-control"
                name="password"
                id="password"
                placeholder="password"
                required
                style={{
                  outlineColor: "red",
                }}
              />
            </div>
            <button
              style={{
                background: "#88b0bc",
                fontSize: 15,
                fontWeight: 300,
                textTransform: "uppercase",
                color: "white",
              }}
              type="submit"
              className="btn btn-xl"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Auth;
